<script setup>
const props = defineProps({
    color: {
        type: String,
        default: "#F7F8F8",
    },
});
</script>
<template>
    <svg viewBox="0 0 24 24" :fill="color" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.26779 12.9836V21.8359H13.3965V13.1065H16.1894L16.918 9.41806H13.3965C13.3965 9.41806 13.3965 7.69678 13.3965 6.71318C13.3965 6.34433 13.5179 5.85254 14.125 5.85254C14.9751 5.85254 16.0679 5.85254 16.0679 5.85254V2.16406C16.0679 2.16406 14.2465 2.16406 12.3036 2.16406C11.0893 2.16406 9.26779 3.7624 9.26779 5.60664C9.26779 7.45088 9.26779 9.41806 9.26779 9.41806H7.08203V13.1065L9.26779 12.9836Z"
        />
    </svg>
</template>
